module.exports = __webpack_public_path__ + "static/media/doc.c56e77cb.png";